import { useState } from 'react';
import { TaiKhoan } from '@/types/schemas';

export const useSearchFieldStates = (initialData?: any) => {
  const convertData = (data: string[]): any => {
    return data.map((code: string, idx: number) => ({
      uuid: idx.toString(),
      code
    }));
  };
  console.log(convertData(initialData?.tk || []));
  const [taiKhoan, setTaiKhoan] = useState<TaiKhoan[]>(convertData(initialData?.tk || []));
  const [taiKhoanDoiUng, setTaiKhoanDoiUng] = useState<TaiKhoan[]>(convertData(initialData?.tk_du || []));
  const [taiKhoanGiamTru, setTaiKhoanGiamTru] = useState<TaiKhoan[]>(convertData(initialData?.tk_gt || []));
  return {
    taiKhoan,
    setTaiKhoan,
    taiKhoanDoiUng,
    setTaiKhoanDoiUng,
    taiKhoanGiamTru,
    setTaiKhoanGiamTru
  };
};
